import { useLayoutEffect } from 'react'
import type { ProductConfig } from './registry'
export function useProductTheme(config: ProductConfig | null) {
  useLayoutEffect(() => {
    if (!config) return
    const style = document.documentElement.style
    const previous = Object.keys(config.theme).map((key) => [key, style.getPropertyValue(key)])
    for (const [key, value] of Object.entries(config.theme)) style.setProperty(key, value)
    return () => { for (const [key, value] of previous) { if (value) style.setProperty(key, value); else style.removeProperty(key) } }
  }, [config])
}
